import React from 'react';

import { Stack, StackProps } from '@mantine/core';
import { t } from 'i18next';
import { ManageSmartAssistantSectionControlWrapper } from 'pages/ManageSmartAssistant/ManageSmartAssistantControlWrapper';

interface ToolConfigurationPanelWrapperProps extends StackProps {
  children: React.ReactNode;
  onSave: () => void;
  onCancel: () => void;
  onBack: () => void;
  hasChanges: boolean;
}

export function ToolConfigurationPanelWrapper({
  onSave,
  onBack,
  onCancel,
  hasChanges,
  children,
  ...stackProps
}: ToolConfigurationPanelWrapperProps) {
  return (
    <ManageSmartAssistantSectionControlWrapper
      title={t('SMART_ASSISTANT.TOOLS_SECTION.CONFIGURATION.TITLE')}
      onBack={onBack}
      onSave={onSave}
      hasChanges={hasChanges}
      onCancel={onCancel}>
      <Stack spacing="lg" px={20} {...stackProps}>
        {children}
      </Stack>
    </ManageSmartAssistantSectionControlWrapper>
  );
}
